// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  width: 48rem;
  background: var(--white);
  border-radius: 1.2rem;
  box-shadow: 0 1.6rem 3.2rem rgba(44, 39, 56, 0.04), 0 3.2rem 6.4rem rgba(44, 39, 56, 0.08);
  display: block;
}

.header {
  height: 5.6rem;
  color: var(--dlack);
  background: var(--white);
  padding: 0 2rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.header .title {
  font-size: 1.6rem;
  line-height: 1.9rem;
  letter-spacing: 0.005em;
}
.header .icon-cancel {
  font-size: 1.8rem;
  cursor: pointer;
}

.content {
  padding: 3.4rem 5rem 4rem;
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  background: var(--bg);
}
.content .col-name {
  width: 100%;
}
.content .col-value {
  width: 60%;
}
.content a[app-icon-button] {
  color: var(--red);
}
.content .actions {
  margin-top: 4rem;
  display: flex;
  justify-content: flex-start;
  gap: 2rem;
}`, "",{"version":3,"sources":["webpack://./src/shared/popups/form-control/form-control-popup.component.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,wBAAA;EACA,qBAAA;EACA,0FACE;EAEF,cAAA;AADF;;AAIA;EACE,cAAA;EACA,mBAAA;EACA,wBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;AADF;AAGE;EACE,iBAAA;EACA,mBAAA;EACA,uBAAA;AADJ;AAIE;EACE,iBAAA;EACA,eAAA;AAFJ;;AAMA;EACE,yBAAA;EACA,aAAA;EACA,uBAAA;EACA,sBAAA;EACA,qBAAA;AAHF;AAKE;EACE,WAAA;AAHJ;AAME;EACE,UAAA;AAJJ;AAOE;EACE,iBAAA;AALJ;AAQE;EACE,gBAAA;EACA,aAAA;EACA,2BAAA;EACA,SAAA;AANJ","sourcesContent":[":host {\n  width: 48rem;\n  background: var(--white);\n  border-radius: 1.2rem;\n  box-shadow:\n    0 1.6rem 3.2rem rgba(44, 39, 56, 0.04),\n    0 3.2rem 6.4rem rgba(44, 39, 56, 0.08);\n  display: block;\n}\n\n.header {\n  height: 5.6rem;\n  color: var(--dlack);\n  background: var(--white);\n  padding: 0 2rem;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n\n  & .title {\n    font-size: 1.6rem;\n    line-height: 1.9rem;\n    letter-spacing: 0.005em;\n  }\n\n  & .icon-cancel {\n    font-size: 1.8rem;\n    cursor: pointer;\n  }\n}\n\n.content {\n  padding: 3.4rem 5rem 4rem;\n  display: flex;\n  align-items: flex-start;\n  flex-direction: column;\n  background: var(--bg);\n\n  & .col-name {\n    width: 100%;\n  }\n\n  & .col-value {\n    width: 60%;\n  }\n\n  a[app-icon-button] {\n    color: var(--red);\n  }\n\n  & .actions {\n    margin-top: 4rem;\n    display: flex;\n    justify-content: flex-start;\n    gap: 2rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
